export const fetchTotalBurned = async (): Promise<number> => {
  try {
    const response = await fetch('https://solama-tracker.443264439.xyz/total-burned');
    const data = await response.json();
    return data.totalBurned || 0;
  } catch (error) {
    console.error('Error fetching total burned:', error);
    return 0;
  }
};
